// extracted by mini-css-extract-plugin
export default {"icon":"ImportantCard_icon__7Nmtw"};